define('views/components/cd_manager/cd_manager_list',['require','views/base/list_view','views/components/cd_manager/cd_manager','text!templates/components/cd_manager/cd_manager_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/cd_manager/cd_manager');

    var temp = require("text!templates/components/cd_manager/cd_manager_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

